import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Lock, Search } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

const LINKS = [
  { to: "/", label: "Home", end: true },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/servizi", label: "Servizi" },
  { to: "/traccia", label: "Traccia spedizione" },
  { to: "/contatti", label: "Contatti" },
];

const linkCls = ({ isActive }) =>
  `relative py-2 text-[13px] font-semibold uppercase tracking-[0.14em] transition-colors duration-200 ${
    isActive ? "text-white after:absolute after:left-0 after:-bottom-0.5 after:h-[2px] after:w-full after:bg-[#E50914]" : "text-slate-400 hover:text-white"
  }`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/85 border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between gap-6">
        <Link to="/" className="shrink-0" data-testid="header-logo-link">
          <img src="/logo.jpg" alt="LINCESSO GROUP TRASPORTI" className="h-12 sm:h-16 w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={linkCls} data-testid={`nav-${l.to.replace(/\//g, "") || "home"}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <Link to="/admin" className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-slate-400 hover:text-white transition-colors" data-testid="header-admin-link">
            <Lock className="h-3.5 w-3.5" /> Area riservata
          </Link>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="lg:hidden p-2 text-white" aria-label="Apri menu" data-testid="mobile-menu-btn">
              <Menu className="h-6 w-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-[#0B0C0E] border-white/10 text-white w-72">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <img src="/logo.jpg" alt="" className="h-16 w-auto mb-8" />
            <div className="flex flex-col gap-2">
              {LINKS.map((l) => (
                <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setOpen(false)} className={linkCls} data-testid={`mobile-nav-${l.to.replace(/\//g, "") || "home"}`}>
                  {l.label}
                </NavLink>
              ))}
              <Link to="/traccia" onClick={() => setOpen(false)} className="mt-6 inline-flex items-center justify-center gap-2 bg-[#E50914] py-3 font-bold uppercase tracking-wider text-sm" data-testid="mobile-track-btn">
                <Search className="h-4 w-4" /> Traccia spedizione
              </Link>
              <Link to="/admin" onClick={() => setOpen(false)} className="mt-3 inline-flex items-center gap-2 text-xs uppercase tracking-widest text-slate-400" data-testid="mobile-admin-link">
                <Lock className="h-3.5 w-3.5" /> Area riservata
              </Link>
            </div>
          </SheetContent>
        </Sheet>
      </div>
      <div className="flag-bar h-[3px] opacity-80" />
    </header>
  );
};
